import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faInstagram,
  faLinkedin,
  faXTwitter,
} from "@fortawesome/free-brands-svg-icons";
import { PortableText } from "@portabletext/react";
import client from "./../../../client";
import "./BlogAuthor.css";

export default function BlogAuthor() {
  const [author, setAuthor] = useState(null);

  useEffect(() => {
    client
      .fetch(
        `*[_type == "author"][0]{
          _id,
          name,
          designation,
          slug,
          instagram,
          facebook,
          youtube,
          "bio": bio[]{..., asset->},
          mainImage{
            asset->{
              _id,
              url
            }
          }
        }`
      )
      .then((data) => {
        console.log("Fetched author:", data);
        setAuthor(data);
      })
      .catch(console.error);
  }, []);

  if (!author) return <p>Loading...</p>;

  return (
    <div className="blogAuthorContainer">
      <div className="blogAuthorContent">
        <div className="blogAuthorImg">
          {author.mainImage?.asset?.url && (
            <img
              src={author.mainImage.asset.url}
              alt={author.name || "Author image"}
            />
          )}
        </div>

        <div className="blogAuthorName">
          <h4>{author.designation}</h4>
          <h3>{author.name}</h3>
        </div>
      </div>

      {/* ❌ Removed <p> wrapper */}
      <div className="blogAuthorContent">
        <PortableText value={author.bio} />
      </div>

      <div className="blogAuthorSocial">
        {author.instagram && (
          <a href={author.instagram} target="_blank" rel="noreferrer">
            <FontAwesomeIcon icon={faInstagram} className="authorSocialIcon" />
          </a>
        )}

        {author.facebook && (
          <a href={author.facebook} target="_blank" rel="noreferrer">
            <FontAwesomeIcon icon={faLinkedin} className="authorSocialIcon" />
          </a>
        )}

        {author.youtube && (
          <a href={author.youtube} target="_blank" rel="noreferrer">
            <FontAwesomeIcon icon={faXTwitter} className="authorSocialIcon" />
          </a>
        )}
      </div>
    </div>
  );
}